import React from 'react';

import LogoTIWithIconTI from '@components/Images/Rebranding/LogoTIWithIconTI';
import useServerSideRendering from '@hooks/useServerSideRendering';
import { topic_landing_path } from '@routes';
import { getImgixSrc } from '@utils/images';

import { ArticleTimeLineEvent } from './timeLineEvents';

const ARTICLE_STYLES =
  'w-full border-0 border-b-2 border-solid h-[200px] relative border-grayscale-gray';
const ARTICLE_STYLES_BEFORE = `before:content-[''] before:absolute before:h-10
  before:left-[calc(10.5%_+_117px)] before:right-[274px] before:bottom-0
  before:bg-[repeating-linear-gradient(to_right,#fff,#fff_11%,#ffffff_11%,#ffffff_11.5%)]`;

interface HorizontalTimePointProps {
  articles: ArticleTimeLineEvent;
}

const HorizontalTimePoint = ({ articles }: HorizontalTimePointProps) => {
  const hydrated = useServerSideRendering();
  const tiArticle = articles[0];
  const externalArticle = articles[1];

  return (
    <article className={`${ARTICLE_STYLES} ${ARTICLE_STYLES_BEFORE}`}>
      <a
        className="topic-badge track-link absolute bottom-10 left-0"
        data-type="link"
        data-name={`topic badge: ${tiArticle.topic}`}
        data-location="brand_campaign#index"
        href={topic_landing_path({ topic: tiArticle.topic })}
      >
        {tiArticle.topic}
      </a>
      <div className="absolute left-0 top-0 ml-[10.5%] h-full w-[420px]">
        <LogoTIWithIconTI
          className="absolute left-0 h-48 max-w-[265px]"
          aria-label="The Information logo"
        />
        <div className="absolute left-[27.9%] top-[4rem] w-full max-w-[260px]">
          <a
            className="text-left font-suisse-intl text-button-lg leading-6 tracking-normal underline sm:text-[22px] sm:leading-8"
            href={tiArticle.articleLink}
          >
            “{tiArticle.articleTitle}”
          </a>
        </div>
        {hydrated && (
          <img
            className="absolute left-[22.6%] top-72"
            src={getImgixSrc({
              path: 'brand_campaign/pinRed.svg',
              isEnvDependent: false,
            })}
            alt="TI Time Line"
          />
        )}
        <div className="absolute -bottom-48 left-0 w-1/2 text-center font-suisse-intl-mono text-overline text-primary-magenta">
          {tiArticle.month} {tiArticle.year}
        </div>
      </div>

      <div className="absolute right-0 top-0 h-full w-[340px]">
        {hydrated && (
          <img
            className="absolute left-0 top-[1rem] max-w-[150px]"
            src={getImgixSrc({
              path: externalArticle.logoPath,
              isEnvDependent: false,
            })}
            alt="TI Time Line"
          />
        )}
        <div className="absolute left-[26.5%] top-[4rem] w-full max-w-[260px] font-suisse-neue text-[16px] leading-6 sm:leading-6">
          “{externalArticle.articleTitle}”
        </div>
        {hydrated && (
          <img
            className="absolute left-[19.4%] top-72"
            src={getImgixSrc({
              path: 'brand_campaign/pinGray.svg',
              isEnvDependent: false,
            })}
            alt="TI Time Line"
          />
        )}
        <div className="absolute -bottom-48 w-[47.1%] text-center font-suisse-intl-mono text-overline">
          {externalArticle.month} {externalArticle.year}
        </div>
      </div>
    </article>
  );
};

export default HorizontalTimePoint;
